module.exports = "<div>{{hint.text}}</div>\n"